export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/collapse/index.js
// module id = 1037
// module chunks = 26